import { Handle, Position, NodeResizer, type NodeProps } from "@xyflow/react";
import { Atom02 } from "@untitledui/icons";
import type { AgentType } from "@/types/workflow";
import { useTranslation } from "react-i18next";

export const AgentNode = ({ data, selected }: NodeProps) => {
    const { t } = useTranslation('pages:workflows-admin');
    const agentType = (data?.agent_type as AgentType | undefined);
    const dataLabel = (data?.label as string) || "";

    const agentTypeLabels: Record<AgentType, string> = {
        postino: t('workflows.editor.agentTypes.postino'),
        classificatore: t('workflows.editor.agentTypes.classificatore'),
        parser: t('workflows.editor.agentTypes.parser'),
        validatore: t('workflows.editor.agentTypes.validatore'),
    };

    const label = agentType ? agentTypeLabels[agentType] : dataLabel || t('workflows.editor.defaultLabels.agent');

    return (
        <div className="rounded-lg bg-utility-blue-50 border-2 border-utility-blue-500 shadow-md min-w-[150px] w-full h-full">
            <NodeResizer
                color="#3b82f6"
                isVisible={selected}
                minWidth={150}
                minHeight={60}
            />
            <Handle type="target" position={Position.Top} className="w-3 h-3 bg-utility-blue-500" />
            <Handle type="source" position={Position.Bottom} className="w-3 h-3 bg-utility-blue-500" />
            <div className="flex flex-col gap-1 px-3 py-2 h-full justify-center">
                <div className="flex items-center gap-2 flex-wrap">
                    <Atom02 className="size-4 text-utility-blue-600 flex-shrink-0" />
                    <span className="text-sm font-semibold text-utility-blue-700 break-words">{label}</span>
                </div>
                {agentType && (
                    <span className="text-xs text-utility-blue-600 opacity-75 break-words">{agentType}</span>
                )}
            </div>
        </div>
    );
};
